import { useI18n } from "../i18n/I18nContext";
import { useSiteContent } from "../context/SiteContentContext";

export default function Terms() {
  const { t, lang } = useI18n();
  const { content } = useSiteContent();
  const c = (key) => content[key]?.[lang] || content[key]?.en || "";
  return (
    <main className="max-w-[820px] mx-auto px-6 md:px-12 pt-16 pb-24" data-testid="terms-page">
      <div className="label-caps text-muted-foreground mb-4">
        {lang === "fi" ? "Toimitusehdot" : lang === "sv" ? "Villkor" : "Terms"}
      </div>
      <h1 className="font-hand text-5xl md:text-6xl mb-10">
        {lang === "fi" ? "Toimitus- ja palautusehdot" : lang === "sv" ? "Leverans- och returvillkor" : "Delivery & return terms"}
      </h1>

      <p className="whitespace-pre-line text-base text-foreground/80 leading-relaxed mb-12">
        {c("terms_intro")}
      </p>

      <div className="mb-12 p-6 border border-border bg-white/40 text-sm">
        <div className="font-semibold mb-1">{c("business_name")}</div>
        <div className="text-muted-foreground">{c("business_address")}</div>
        <div className="text-muted-foreground">p. {c("footer_phone")}</div>
        <div className="text-muted-foreground">{c("footer_email")}</div>
        <div className="text-muted-foreground mt-2 text-xs">
          Y-tunnus: {c("business_id")} · {c("business_vat_note")}
        </div>
      </div>

      <Section title={lang === "fi" ? "Maksaminen" : lang === "sv" ? "Betalning" : "Payment"} body={c("terms_payment")} />
      <Section title={lang === "fi" ? "Toimitus ja toimituskulut" : lang === "sv" ? "Leverans och fraktkostnader" : "Delivery & shipping"} body={c("terms_delivery")} />
      <Section title={lang === "fi" ? "Toimitusaika" : lang === "sv" ? "Leveranstid" : "Delivery time"} body={c("terms_delivery_time")} />
      <Section title={lang === "fi" ? "Peruuttaminen ja palautukset" : lang === "sv" ? "Ångerrätt och returer" : "Right of withdrawal & returns"} body={c("terms_returns")} />
      <Section title={lang === "fi" ? "Asiakaspalvelu" : lang === "sv" ? "Kundtjänst" : "Customer service"} body={c("terms_support")} />
    </main>
  );
}

function Section({ title, body }) {
  return (
    <section className="mb-10">
      <h2 className="font-hand text-3xl mb-4">{title}</h2>
      <p className="whitespace-pre-line text-base text-foreground/80 leading-relaxed">{body}</p>
    </section>
  );
}
